import { Col, Row, Button, Container } from 'react-bootstrap';
import '../Global.css';
import Card from 'react-bootstrap/Card';
import 'bootstrap/dist/css/bootstrap.min.css';
import Navbar from '../components/Navbar';
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from 'react';
import api from '../api';

function TournamentDetail() {
    const [tournament, setTournament] = useState(null);

    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const { id } = useParams(); // URL'den turnuva ID'sini alıyoruz
    const token = localStorage.getItem('JWTTOKEN');

   

    const getTournamentDetail = async () => {
        try {
            // Tekil turnuva detayını çeken endpoint (Kendi API yapına göre düzenleyebilirsin)
            const token = localStorage.getItem("JWTTOKEN");
            const res = await api.get(`/v1/tournament/pending/${id}`, { headers: { Authorization: `Bearer ${token}` } });
            setTournament(res.data.data);
        } catch (err) {
            console.log(err);
            alert("Turnuva detayları alınamadı.");
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (!token) {
            navigate("/login");
            return;
        }
        getTournamentDetail();
    }, [id]);

    const handleStatusUpdate = async (newStatus) => {
        try {
            const token = localStorage.getItem("JWTTOKEN");
            await api.post(`/v1/tournament/pending/update`, { status: newStatus, _id: id }, { headers: { Authorization: `Bearer ${token}` } });

            navigate(-1); // İşlem sonrası bir önceki sayfaya (bekleyenlere) geri döndürür
        } catch (err) {
            console.log("Statü güncellenirken hata oluştu:", err);
            alert("Bir hata oluştu, lütfen tekrar deneyin.");
        }
    };

    if (loading) {
        return (
            <div className="app-container">
                <Navbar />
                <div className="main-content" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <b style={{ color: "white", fontSize: 20 }}>Detaylar Yükleniyor...</b>
                </div>
            </div>
        );
    }

    if (!tournament) return null;

    return (
        <div className="app-container">
            <Navbar />
            <div className="main-content">

                {/* Üst Kısım: Turnuva Genel Bilgileri ve Aksiyon Butonları */}
                <div className="d-flex justify-content-between align-items-center mb-4" style={{ borderBottom: '1px solid #333', paddingBottom: '20px' }}>
                    <div>
                        <h2 style={{ color: 'white', margin: 0 }}>{tournament.title}</h2>
                        <span style={{ color: '#8b8b8b', fontSize: '14px' }}>
                            Kategori: {tournament.category} | Oluşturan: {tournament.createdBy} | İçerik Sayısı: {tournament.decisions?.length || 0}
                        </span>
                    </div>
                    <div>
                        <Button variant="outline-light" className="me-2" onClick={() => navigate(-1)}>Geri Dön</Button>
                        <Button variant="danger" className="me-2" onClick={() => handleStatusUpdate('denied')}>Reddet</Button>
                        <Button variant="success" onClick={() => handleStatusUpdate('verified')}>Onayla ve Yayınla</Button>
                    </div>
                </div>

                <h4 style={{ color: 'white', marginBottom: '20px' }}>Turnuva İçeriği (Eşleşmeler/Seçenekler)</h4>

                {/* Alt Kısım: Decisions (Turnuva Seçenekleri) Listesi */}
                <Row>
                    {tournament.decisions && tournament.decisions.length > 0 ? (
                        tournament.decisions.map((decision, index) => (
                            <Col key={decision._id || index} xs={6} md={4} lg={3} xl={2}>
                                <Card style={{ backgroundColor: 'transparent', border: '1px solid #252525' }} className='mb-4 rounded-3 overflow-hidden'>
                                    <Card.Img
                                        variant="top"
                                        src={decision.image || 'https://via.placeholder.com/150'}
                                        style={{ height: '140px', objectFit: 'cover' }}
                                    />
                                    <Card.Body style={{ backgroundColor: '#121212', padding: '10px' }}>
                                        <Card.Title style={{ color: "white", fontSize: '14px', textAlign: 'center', margin: 0 }}>
                                            {decision.title}
                                        </Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                        ))
                    ) : (
                        <div style={{ color: '#8b8b8b', marginTop: '20px' }}>Bu turnuvaya ait içerik/seçenek bulunamadı.</div>
                    )}
                </Row>

            </div>
        </div>
    );
}

export default TournamentDetail;